import { render, staticRenderFns } from "./AddBankComponent.vue?vue&type=template&id=23e2db42&"
import script from "./AddBankComponent.vue?vue&type=script&lang=js&"
export * from "./AddBankComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddBankComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports